<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-row vs-type="flex" vs-justify="end">
        <vs-col vs-w="12" style="display: inline-flex">
          <div class="con-input-search vs-table--search">
            <input
              class="input-search vs-table--search-input mt-1 w-full"
              type="text"
              v-model="text"
              @keypress.enter="search"
            />
            <vs-icon icon="search"></vs-icon>
          </div>
           <vs-button color="danger" type="filled" radius icon-pack="feather" icon="icon-plus" class="mt-4 mx-2" @click="addCell"></vs-button>
        </vs-col>

      </vs-row>
    </template>
    <template slot="thead">
      <vs-th class="f-14">
        {{ $t('name') | capitalize }}
      </vs-th>
      <vs-th class="f-14">
        {{ $t('clients') | capitalize }}
      </vs-th>
      <vs-th class="f-14">
        {{ $t('users') | capitalize }}
      </vs-th>
      <vs-th> </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td :data="data[i].email">
          {{ data[i].name }}
        </vs-td>

        <vs-td :data="data[i].cell_clients">
          <ul>
            <li :key="idxC" v-for="(client, idxC) in data[i].cell_clients">
              <color-icon :color="client.color" />
              {{ client.client_data.ClientName }}
            </li>
          </ul>
        </vs-td>

        <vs-td :data="data[i].cell_users">
          <ul>
            <li :key="idxU" v-for="(user, idxU) in data[i].cell_users">
              {{ user.user_data.name }}
            </li>
          </ul>
        </vs-td>

        <vs-td :data="data[i].id">
          <action-icon
            icon="EditIcon"
            :tooltip="$t('edit') | capitalize"
            @click="editCell(data[i].id)"
          />
          <action-icon
            icon="TrashIcon"
            :tooltip="$t('delete') | capitalize"
            @click="deleteCell(data[i].id)"
          />
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ColorIcon from '@/views/qb-components/ColorIcon'
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ActionIcon,
    ColorIcon,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    search() {
      this.$emit('search', this.text)
    },
    addCell(event) {
      this.$emit('add', event)
    },
    editCell(event) {
      this.$emit('edit', event)
    },
    deleteCell(event) {
      this.$emit('delete', event)
    },
  },
}
</script>

<style>
</style>